import { useEffect } from 'react';

const useDigicertBadge = (): void => {
    useEffect(() => {
        // allow digicert script badge to load on initial page load
        setTimeout(() => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            const code = 'var __dcid = __dcid || []; __dcid.push(["DigiCertClickID_CBu92egn", "7", "s", "black", "CBu92egn"]); (function () { var cid = document.createElement("script"); cid.async = true; cid.src = "//seal.digicert.com/seals/cascade/seal.min.js"; var s = document.getElementsByTagName("script"); var ls = s[(s.length - 1)]; ls.parentNode.insertBefore(cid, ls.nextSibling); }());';

            const digicert = document.getElementsByClassName('digicert-container');
            try {
                script.appendChild(document.createTextNode(code));
                if (digicert && digicert.length > 0) {
                    (digicert[0] as HTMLElement).appendChild(script);
                }
            } catch (error) {
                script.text = code;
                if (digicert?.length > 0) {
                    (digicert[0] as HTMLElement).appendChild(script);
                }
            }
        }, 500);

        return function cleanup() {
            const digicertScripts =
                Array.from(document.getElementsByTagName('script'))
                    .filter((s) => {return s.src === 'https://seal.digicert.com/seals/cascade/seal.min.js';});
            if (digicertScripts.length > 0)  {
                (digicertScripts[0] as HTMLElement).remove();
            }
        };
    }, []);
};

export default useDigicertBadge;
